import { ItemOrderabilityStatus, CartItem } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const isItemAvailable = (item: CartItem | null | undefined): boolean =>
    !isEmpty(item) &&
    item!.in_stock === 1 &&
    item!.item_orderability_status?.status !== ItemOrderabilityStatus.NOT_ORDERABLE;
